import { useState } from 'react';
import { routes } from '../Helpers/Configuration';
import MFAHome from './MFAHome';
import RecoveryCodeReadOnly from './RecoveryCodeReadOnly';
import RecoveryCode from './RecoveryCode';
import MFAResetConfirm from './MFAResetConfirm';
import LostRecoveryCode from './LostRecoveryCode';
import { Route, Switch } from 'react-router-dom';
import MFAContext from './MFAContext';
import { SnackbarProvider } from '../SnackbarContext/SnackbarContext';

const MFAWrapper = () => {
    const [qrCodeInfo, setQRCodeInfo] = useState({});

    const mfaCtx = {
        qrCodeInfo,
        setQRCodeInfo,
    };

    return (
        <MFAContext.Provider value={mfaCtx}>
            <SnackbarProvider>
                <Switch> 
                    <Route exact
                        path={routes.totpRecovery}
                        component={RecoveryCodeReadOnly}
                    />
                    <Route exact
                        path={routes.totpReset}
                        component={RecoveryCode}
                    />
                    <Route exact
                        path={routes.totpLostRecoveryCode}
                        component={LostRecoveryCode}
                    />
                    <Route exact
                        path={routes.totpResetConfirm}
                        component={MFAResetConfirm}
                    />
                    <Route
                        path='/'
                        component={MFAHome}
                    />
                </Switch>
            </SnackbarProvider>
        </MFAContext.Provider>
    );
};

export default MFAWrapper;